import { request } from "./base";

export const childDealers = (dealerCode: string, date: Date, dealerCodes: string[]): Promise<{ dealers: string[] }> =>
  request(`/dealers/children/${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, "0")}`, {
    method: "POST",
    body: JSON.stringify({ dealerCode: dealerCode, dealerCodes: dealerCodes }),
  })
    .then(res => res.json())
    .then(({ data }) => data);

export const postCubeReload = async (data: { dealerCodes: string[]; startMonth: string; endMonth: string }) => {
  const response = await request("/dealers/cube-reload", {
    method: "POST",
    body: JSON.stringify(data),
  });
  if (response.status < 400) {
    return;
  }
  const { error } = await response.json();
  const err = { error: error.message, statusCode: response.status };
  throw err;
};

export const fetchLocationsForDealers = async (dealerCodes: string[]): Promise<{ [dealerCode: string]: { latitude: number; longitude: number } }> => {
  const response = await request(`/dealers/locations`, {
    method: "POST",
    body: JSON.stringify({ dealerCodes }),
  });
  if (response.status < 400) {
    return (await response.json().then(({ data }) => data)) as { [dealerCode: string]: { latitude: number; longitude: number } };
  }
  const err = { error: `Failed to fetch location for dealers ${dealerCodes.join(", ")}`, statusCode: response.status };
  throw err;
};
